const clearStream = (stream?: MediaStream | null) => stream?.getTracks().forEach(track => track.stop());

export default clearStream;
